import Tippy from "@tippyjs/react";
import "./styles.css";
import { useNavigate } from "react-router-dom";

export default function AgeRating({ age_rating, linkRedirect }) {
    const navigate = useNavigate(); // useNavigate no lugar de useNavigation

    const redirect = (link) => {
        navigate(link);
    };

    return (
        <Tippy content={age_rating == 0 ? `Classificação indicativa: Livre` : `Classificação indicativa: ${age_rating} Anos`}>
            <section style={{cursor: `${linkRedirect ? 'pointer' : 'default'}`}} onClick={() => linkRedirect ? redirect(linkRedirect) : null}>
                <span className={`span-classificacao-indicativa span-classificacao-indicativa-${age_rating}`}>
                    {age_rating == 0 ? "L" : age_rating}
                </span>
            </section>
        </Tippy>
    );
}
